import type { LawFirmReceipt, PagedList } from '~/models'
import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'

export const Get = params => $apiGet<PagedList<LawFirmReceipt>>(`/v1/lawFirmReceipt`, params)

export const GetCurrentReceiptNumber = params => $apiGet<number>(`/v1/lawFirmReceipt/currentReceiptNumber`, params)

export const GetByEncryptionId = encryptionId => $apiGet<LawFirmReceipt>(`/v1/lawFirmReceipt/${encryptionId}`)

export const Discard = (encryptionId, body) => $apiPut<void>(`/v1/lawFirmReceipt/discard/${encryptionId}`, body)

export const CancelDiscard = encryptionId => $apiPut<void>(`/v1/lawFirmReceipt/cancelDiscard/${encryptionId}`)

export const Post = body => $apiPost<void>(`/v1/lawFirmReceipt`, body)

export const Put = (encryptionId, body) => $apiPut<void>(`/v1/lawFirmReceipt/${encryptionId}`, body)

export const Remove = encryptionId => $apiPut<void>(`/v1/lawFirmReceipt/remove/${encryptionId}`)
